module.exports = __webpack_public_path__ + "static/pizza-b066fc467f93fa8de66ba3919fa58dbc.svg";